import { DatasetMetadata } from "@tblabs/storage";
import { Div, JsonViewer, Line, Button } from "@tblabs/truffle";
import { Panel } from "../Components/Panel";


export class MetadataViewBox extends Div
{
    constructor(private datasetName: string, private dataset: DatasetMetadata)
    {
        super();
    }

    protected async OnAppend()
    {
        this.Append(
            new Panel("Metadata", [
                new JsonViewer(this.dataset, undefined, {
                    keyStyle: "color: #d2d2d2;",
                    stringStyle: "color: #fdfdfd;",
                    numberStyle: "color: #fdfdfd;",
                    boolStyle: "color: #fdfdfd;",
                    nullStyle: "color: #fdfdfd;",
                    foldAll: false
                }),
                new Line().Opacity(0.7),
                new Button("Edit").OnClick(async () => window.location.hash = `admin/dataset/${this.datasetName}/metadata/edit`).MarginLeft(12),
            ])
        );
    }
}
